import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import BriefForm from './form';

const mapStateToProps = state => ({
  permissionsMap: state.entitlements.permissionsMap,
  permissionsFetching: state.entitlements.fetching,
  permissionFetchError: state.entitlements.error
});

const mapDispatchToProps = dispatch => ({
  fetchUserPermissions: accountId => dispatch(actions.fetchUserPermissions(accountId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BriefForm);



// WEBPACK FOOTER //
// ./app/javascript/app/components/brief_templates/brief_template_form.js